export default __webpack_public_path__ + "static/media/icon-GMX_full.1d0dc1c6.svg";